var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-input',{attrs:{"placeholder":_vm.placeholder,"autocomplete":"off"},model:{value:(_vm.bic),callback:function ($$v) {_vm.bic=$$v},expression:"bic"}})
}
var staticRenderFns = []

export { render, staticRenderFns }